import { render, staticRenderFns } from "./LabelActivityLogs.vue?vue&type=template&id=3880cac8&scoped=true"
import script from "./LabelActivityLogs.vue?vue&type=script&lang=js"
export * from "./LabelActivityLogs.vue?vue&type=script&lang=js"
import style0 from "./LabelActivityLogs.vue?vue&type=style&index=0&id=3880cac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3880cac8",
  null
  
)

export default component.exports